import { useHubSpotDispatch, useHubSpotState } from "../hubSpot";
import { runWithOwner } from "solid-js";
import owner from "../owner";

export const directUserToSupport = () => {
  runWithOwner(owner(), () => {
    const state = useHubSpotState();
    const { open } = useHubSpotDispatch();

    if (state.loaded) {
      open();
    } else {
      // HubSpot widget is not available, send user to our Help Center
      window.open("https://helpcenter.moreapp.com", "_blank");
    }
  });
};
